<template>
  <OTooltip v-if="item.isInvalid" :text="item.result?.message ?? ''" class="w-max">
    <OChip size="sm" variant="danger" flat>
      <OIcon icon="danger" :size="13" class="-ml-1 p-2px rounded md:mr-2" />
      {{ $t('pages.account.index.exports.invalid') }}
    </OChip>
  </OTooltip>
  <div v-else-if="item.isExpired" class="flex items-center text-gray-500 dark:text-gray-400">
    <OIcon fill icon="x" :size="14" />
    <p class="ml-2">{{ $t('general.expired') }}</p>
  </div>
  <div v-else-if="item.isComplete" class="flex items-center text-green-500">
    <OIcon fill icon="check" :size="12" />
    <p class="ml-2">{{ $t('general.complete') }}</p>
  </div>
  <div v-else-if="item.isError" class="flex items-center text-red-500">
    <OIcon fill icon="x" :size="14" />
    <p class="ml-2">{{ $t('general.error') }}</p>
  </div>
  <div v-else-if="item.isRunning" class="flex items-center text-blue-500">
    <OIcon fill icon="refresh" :size="14" class="animate-spin" />
    <p class="ml-2">{{ $t('export.running') }}</p>
  </div>
  <div v-else-if="item.isQueued" class="flex items-center text-gray-500 dark:text-gray-400">
    <span class="w-3 h-px rounded-full bg-gray-500 block" />
    <p class="ml-2">{{ $t('general.queued') }}</p>
  </div>
</template>

<script setup lang="ts">
import { OChip, OIcon, OTooltip } from '@/components/elements'
import type { ExportModel } from '@/_api/models/export'

defineProps<{ item: ExportModel }>()
</script>
